export const HALF_LIFE_HOURS_BY_RATE = {
  fast: 4,
  average: 5.5,
  slow: 7.5
};

export const DEFAULT_SETTINGS = {
  metabolismRate: 'average', // fast, average, slow
  caffeineLimit: 200, // in mg
  sleepTime: '22:00', // 24-hour format
  targetSleepCaffeine: 30, // in mg
  pregnancyAdjustment: false,
  smokerAdjustment: false,
  oralContraceptivesAdjustment: false
};


